import { render, staticRenderFns } from "./RelatedProductCard.vue?vue&type=template&id=8c71deb8&scoped=true&"
import script from "./RelatedProductCard.vue?vue&type=script&lang=js&"
export * from "./RelatedProductCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductCard.vue?vue&type=style&index=0&id=8c71deb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71deb8",
  null
  
)

export default component.exports